module.exports = __webpack_public_path__ + "static/media/cn.3a082904.svg";